import React from 'react';
import PropTypes from 'prop-types';
import './SocialMediaButton.scss';
import SocialMediaButtonProps from '~types/components/SocialMediaButtonProps';

const SocialMediaButton = ({ icon, socialMediaLink, title }: SocialMediaButtonProps) => {
  return (
    <a
      type="button"
      href={socialMediaLink}
      data-testid={`${title}-button`}
      target="_blank"
      title={title}
      rel="noreferrer"
      className="social-media-wrapper"
    >
      <img src={icon} alt="social_media_share_button" role="presentation" />
    </a>
  );
};

SocialMediaButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  socialMediaLink: PropTypes.string.isRequired,
};

export default SocialMediaButton;
